import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";

export default function CenterPage({ kjInfo, userCoinInfo, bubKj }) {
  const navigate = useNavigate();
  const [num, setNum] = useState(1);
  const { t: translate } = useTranslation();
  
  return (
    <div className="flex flex-col w-full max-w-lg mx-auto space-y-6 p-4 bg-neutral-900 text-neutral-100">
      {/* 顶部币种信息 */}
      <div className="flex items-center space-x-4 bg-neutral-800 p-4 rounded-lg">
        <img
          alt=""
          src={imageConfig.baseImageUrl+kjInfo?.imgs}
          className="w-12 h-12 rounded-full"
        />
        <div className="flex-1">
          <div className="flex justify-between items-center">
            <span className="text-sm text-neutral-400">{translate(getText("獲得UDST"))}</span>
            <span className="text-lg font-medium">{kjInfo?.title}</span>
          </div>
          <div className="flex justify-between items-center mt-2">
            <span className="text-sm text-neutral-400">{translate(getText("近日(日收益)"))}</span>
            <span className="text-xl font-bold text-primary">{kjInfo.dayoutnum}%</span>
          </div>
        </div>
      </div>

      {/* 周期和限额信息 */}
      <div className="bg-neutral-800 p-4 rounded-lg">
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="text-center">
            <span className="block text-xl font-bold text-primary">{kjInfo.cycle}{translate(getText("(天)"))}</span>
            <span className="text-sm text-neutral-400">{translate(getText("理財周期"))}</span>
          </div>
          <div className="text-center">
            <span className="block text-xl font-bold text-primary">{kjInfo.min}~{kjInfo.max}</span>
            <span className="text-sm text-neutral-400">{translate(getText("單筆限額"))}</span>
          </div>
        </div>
        <div className="h-px bg-neutral-700 my-4"></div>
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center">
            <span className="block text-sm text-neutral-400">{translate(getText("派息時間"))}</span>
            <span className="block mt-1">{translate(getText("到期結算"))}</span>
          </div>
          <div className="text-center">
            <span className="block text-sm text-neutral-400">{translate(getText("託管資金"))}</span>
            <span className="block mt-1">{translate(getText("到期返回"))}</span>
          </div>
        </div>
      </div>

      {/* 预估收益和可用资产 */}
      <div className="bg-neutral-800 p-4 rounded-lg space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-sm text-neutral-400">{translate(getText("預估收益(USDT)"))}</span>
          <span className="text-xl font-bold text-success">{((num * kjInfo?.dayoutnum) / 100).toFixed(4)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-neutral-400">{translate(getText("可用資產(USDT)"))}</span>
          <span className="text-xl font-bold text-primary">{userCoinInfo?.usdt}</span>
        </div>
      </div>

      {/* 投资金额输入 */}
      <div className="bg-neutral-800 p-4 rounded-lg">
        <span className="block text-sm text-neutral-400 mb-2">{translate(getText("投資金額"))}</span>
        <div className="relative">
          <input
            name="num"
            type="number"
            placeholder={translate(getText("請輸入投資金額"))}
            className="w-full bg-neutral-700 text-neutral-100 rounded-lg px-4 py-3 pr-24 focus:outline-none focus:ring-2 focus:ring-primary"
            min={1}
            value={num}
            onChange={(e) => {
              let value = parseInt(e.target.value);
              setNum(value);
            }}
          />
          <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center space-x-2">
            <span className="text-neutral-400">USDT</span>
            <button
              className="text-primary hover:text-primary-light transition-colors"
              onClick={() => {
                setNum(userCoinInfo?.usdt);
              }}
            >
              {translate(getText("全部"))}
            </button>
          </div>
        </div>
      </div>

      {/* 说明文字 */}
      <div className="text-center space-y-2">
        <span className="block text-lg font-medium">{translate(getText("挖礦賺不停"))}</span>
        <span className="block text-sm text-neutral-400">
          {translate(getText("鎖倉挖礦是通過將USDT託管給平台超算力礦機在平台礦池中進行挖礦收益"))}
        </span>
      </div>

      {/* 认购按钮 */}
      <button
        className="w-full bg-gradient-primary text-white font-medium py-4 rounded-lg hover:opacity-90 transition-opacity active:scale-98 transform"
        onClick={() => {
          bubKj({ kid: kjInfo.id, buynum: num });
        }}
      >
        {translate(getText("認購"))}
      </button>
    </div>
  );
}
